export default __webpack_public_path__ + "static/media/xboxSale.c6f86a9b.png";